// extracted by mini-css-extract-plugin
export default {"infinity":"styles_infinity__a6cV6"};